import request from '@/lib/request/normal';

export const createRecord = data => {
    return request('/record/create', {method: 'POST', body: data});
};

export const queryRecord = data => {
    return request('/record/query', {method: 'POST', body: data});
};

export const queryRecordInfo = id => {
    return request(`/record/info?id=${id}`, {method: 'GET'});
};
